/* istanbul ignore file */

export const FORM_FIELDS = {
  HEADLINE: 'headline',
  STANDFIRST: 'standfirst',
  LANGUAGE: 'language',
  WEBSITES: 'websites',
  INTERNAL_INFORMATION: 'internal_information',
  LIVE_URLS: 'live_urls',
  CONTENT_IDS: 'content_ids',
  ARTICLE_VERSION_LIST: 'article_version_list',
  NEXT_STATES: 'next_states',
  PUBLISH: 'publish',
  DATE: 'date',
  TIMEZONE: 'timezone',
  SHOW_PUBLISH_TIME: 'show_publish_time',
  CONTENT_LISTS: 'content_lists',
  SELECTED_AUTHORS: 'selected_authors',
  SPONSORS: 'sponsors',
  SELECTED_SPONSOR: 'selected_sponsor',
  IS_SPONSORED: 'is_sponsored',
  COLUMNIST_CONTENT: 'columnist_content',
  RELATED_MANAGERS: 'related_managers',
  RELATED_FUNDS: 'related_funds',
  RELATED_SECTORS: 'related_sectors',
  RELATED_ASSET_CLASSES: 'related_asset_classes',
  RELATED_ETFS: 'related_etfs',
  RELATED_INVESTMENT_TRUSTS: 'related_investment_trusts',
  RELATED_SHARES: 'related_shares',
  RELATED_ARTICLES: 'related_articles',
  EXTERNAL_LINKS: 'external_links',
  SURTITLES: 'surtitles',
  EDITION_LANGUAGE: 'edition_language',
  TYPED_TAGS: 'typed_tags',
  TOPICS: 'topics',
  TOPICS_WITH_TRANSLATIONS: 'topics_with_translations',
  TAGS: 'tags',
  COMPANIES: 'companies',
  PEOPLE: 'people',
  RESTRICTED_TO_REGISTERED_USERS: 'restrict_to_registered_users',
  NOT_FOR_GOOGLE_NEWS_SITEMAPS: 'not_for_google_news_sitemaps',
  NOT_FOR_NEWS_FEED: 'not_for_news_feeds',
  HIDE_THIS_ARTICLE: 'hide_this_article',
  PAYWALL_PREMIUM_CONTENT: 'paywall_premium_content',
  NOT_FOR_COMPETITORS: 'not_for_competitors',
  MAIN_IMAGE: 'main_image',
  MAIN_VIDEO: 'main_video',
  SLIDES: 'slides',
  DISPLAY_IMAGE_ON_WEBSITE: 'display_image_on_website',
};
